export default __webpack_public_path__ + "static/media/Showcaseimg.e60e6404.png";